import {
    LIST_ARV_DATA_REQUEST,
    LIST_ARV_DATA_SUCCESS,
    LIST_ARV_DATA_FAILURE
} from "../../../constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
};

const arvListFetcherReducer = (state = initialState, action) => {
    switch (action.type) {
        case LIST_ARV_DATA_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.types,
            };
        case LIST_ARV_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.types,
                error: null,
            };
        case LIST_ARV_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.types,
                data: null,
            };
        default:
            return state;
    }
};

export default arvListFetcherReducer;
